import React, { Component, Fragment } from 'react'
import { MuiGrid, MuiButton, MuiAddCircle, MuiTypography, MuiFab } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import AddSharedRoomComponent from './AddSharedRoomComponent'
import AddRowComponent from './AddRowComponent';
import spinner from "../../../ui/icons/spinner.gif"
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import '../../../ui/scrollbarForLog.css'
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { toast } from 'react-toastify';
import lodashUtil from 'lodash'

export class SharedRoomComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      editFlag: false,
      showAddNewSharedRoomComponent: this.props.showAddNewSharedRoomComponent,
      selectedRoomIndex: undefined,
    }
  }

  renderAddRow = () => {
    this.setState({ editFlag: false, })
    this.state.room = {
      name: undefined,
      roomCount: 1,
      roomCode: "",
      weeklyAvailability: {
        availableForAllHours: "true"
      }
    }
    this.props.addNewSharedRoom()
    return {}
  }

  editRoom = (room) => {
    const i18n = this.props.i18n
    if (room.name === undefined || room.name === "") {
      toast(i18n.sharedRooms.roomNameIsEmpty);
    } else {
      let roomList = this.props.roomList
      let roomPresent = roomList.some((obj) => {
        return (obj.name.toUpperCase() === room.name.toUpperCase() && obj._id != room._id)
      })
      if (roomPresent == true) {
        let repeatingRoomName = StringReplacer.getFormatedMessage(i18n.sharedRooms.repeatingRoomName,
          {
            RoomName: room.name
          })
        toast(repeatingRoomName);
      } else {

        this.props.roomList.splice(this.state.selectedRoomIndex, 1, room)
        this.setState({
          room: {
            weeklyAvailability: {
              availableForAllHours: true,
            }
          },
          editFlag: false
        })
        this.props.cancelAddNewSharedRoom()
      }
    }
  }

  onClickOfEditRoom = (room, index) => {
    this.props.AddNewSharedRoom()
    this.setState({
      room: room,
      editFlag: true,
      selectedRoomIndex: index,
    })
  }

  handleDelete = (key) => {
    let roomList = this.props.roomList
    let deletedRoomObj = { ...roomList[key] }
    this.props.deletedRoomObject(deletedRoomObj)
    roomList.splice(key, 1)
    this.props.confirmDialogSharedRoom.isChanged = true
    this.setState({
      roomList: roomList
    })
  }
  updateData = () => {
    if (!this.props.confirmDialogSharedRoom.isChanged) {
      this.props.confirmDialogSharedRoom.isChanged = true
    }
    this.setState({ toggleChange: !this.state.toggleChange });
  }
  render() {
    if (this.props.updateSchoolinformationInProgress === true) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>

    }
    const { i18n } = this.props
    return (
      <MuiGrid container xs={12} direction="row" id="grid" >
        {this.props.showAddNewSharedRoomComponent ?
          <AddSharedRoomComponent
            {...this.props}
            {...this.state}
            handleClose={this.handleClose}
            addRow={this.props.addRow}
            editRoom={this.editRoom}
            updateData={this.updateData}
          /> :
          <Fragment>
            <MuiGrid container xs={12} direction="row" id="grid" style={{ width: '100vw' }}>

              <PageHeaderComponent {...this.props} title={i18n.sharedRooms.title} subTitle={i18n.sharedRooms.tabDescription} />

              <MuiGrid container xs={12} >
                {/* <MuiGrid container xs={12} style={theme.gridTableStyle}  > */}
                <MuiGrid container xs={12} direction='row' style={theme.tableHeaderStyle}>
                  <MuiGrid item xs={2} >
                    <MuiTypography style={theme.tableHeaderTextStyle}>
                      {i18n.sharedRooms.roomNameHeader}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid item xs={1} >
                    <MuiTypography style={theme.tableHeaderTextStyle}>
                      {i18n.sharedRooms.roomCode}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid item xs={3}>
                    <MuiTypography style={theme.tableHeaderTextStyle}>
                      {i18n.sharedRooms.description}
                    </MuiTypography>
                  </MuiGrid>
                  <MuiGrid item xs>
                    <MuiTypography style={theme.tableHeaderTextStyle}>
                      {i18n.sharedRooms.unavailability}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
                <MuiGrid container id='scrollStyle' xs={12} style={{ maxHeight: '62vh', overflowY: 'auto' }}>
                  {this.props.roomList.length !== 0 && this.props.roomList.map((room, index) =>
                    <MuiGrid container xs={12}  >
                      <AddRowComponent
                        selectedRoom={index}
                        {...this.state}
                        {...this.props}
                        room={room}
                        renderAddRow={this.renderAddRow}
                        onClickOfEditRoom={this.onClickOfEditRoom}
                        handleDelete={this.handleDelete}
                        weeklyAvailabilityList={room.weeklyAvailabilityDisplayList}
                        destructorOfWeeklyAvailabilitySchedule={this.props.destructorOfWeeklyAvailabilitySchedule}
                      />
                    </MuiGrid>
                  )}</MuiGrid>
                <MuiGrid container xs={12} onClick={() => this.renderAddRow()} style={theme.gridActionContainerStyle} justify="center" alignItems="center">
                  <MuiGrid item >

                    <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
                  </MuiGrid>
                  <MuiGrid item >
                    <MuiTypography style={theme.addMoreStyle}>
                      {i18n.sharedRooms.addMoreRooms}
                    </MuiTypography>
                  </MuiGrid>
                </MuiGrid>
                {/* </MuiGrid> */}
              </MuiGrid>
              <MuiGrid container justify="flex-end" style={{ paddingTop: '8px' }}>
                <MuiButton
                  disabled={!this.props.confirmDialogSharedRoom.isChanged}
                  style={!this.props.confirmDialogSharedRoom.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
                  onClick={() => { this.props.onClickOfSave() }} >
                  {i18n.commonTexts.save}
                </MuiButton>
              </MuiGrid>
            </MuiGrid>
          </Fragment>}
      </MuiGrid>
    )
  }
}

export default SharedRoomComponent
